import React from "react";

import { useTranslation } from "react-i18next";
import { currencyFormat } from "simple-currency-format";
import { useTicket } from "../../store/Store";

const Currency = ({ value }) => {
  const { i18n } = useTranslation();
  const defaultLocale = "en-US";

  const currency = useTicket().data?.resource?.company?.currency_uuid || "USD";
  const locale = i18n.language;

  try {
    return currencyFormat(value, locale, currency.toUpperCase(), 2);
  } catch {
    return currencyFormat(value, defaultLocale, currency.toUpperCase(), 2);
  }
};

export default Currency;
